import { Component, Input, Output } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Component({
  selector: 'app-pagination',
  templateUrl: './pagination.component.html',
  styleUrls: ['./pagination.component.css'],
})
export class PaginationComponent {

  @Input() readonly id?: string = null;
  @Input() readonly disabled: boolean = false;

  @Input() readonly pageNumberPrefix: string = 'Page: ';
  @Input() readonly previousLabel: string = 'Previous';
  @Input() readonly previousTitle: string = 'Previous Page';
  @Input() readonly nextLabel: string = 'Next';
  @Input() readonly nextTitle: string = 'Next Page';

  @Output() readonly pageNumber: BehaviorSubject<number> = new BehaviorSubject<number>(1);

  changePageNumber(
    page: number
  ): void {

    if (this.disabled) {
      return;
    }

    this.pageNumber.next(page);
  }

}
